import React, { useState } from 'react';
import API from './services/api';
import './Register.css';

const Register = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleRegister = async (e) => {
    e.preventDefault();

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(username)) {
      setErrorMessage('Username must be a valid email address.');
      return;
    }

    // Validate password strength
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z]).{12,}$/;
    if (!passwordRegex.test(password)) {
      setErrorMessage('Password must be at least 12 characters long and include both upper-case and lower-case characters.');
      return;
    }

    try {
  const response = await API.post('/server/register', {
        first_name: firstName,
        last_name: lastName,
        username,
        password
      });

      // If the response is successful, notify the user
      setSuccessMessage('User registered successfully!');
      setErrorMessage(''); // Clear any previous errors
    } catch (err) {
      if (err.response) {
        // The backend returned an error (status code outside the 2xx range)
        setErrorMessage(err.response.data.error || 'Registration failed.');
      } else if (err.request) {
        // No response received from the server
        setErrorMessage('No response from the server. Please try again later.');
      } else {
        // Other errors like setup issues or request errors
        setErrorMessage('An error occurred. Please try again.');
      }
      setSuccessMessage(''); // Clear any previous success messages
    }
  };

  return (
    <div className="register-container">
      <h2>Register</h2>
      <form onSubmit={handleRegister}>
        <div className="form-group">
          <label>First Name</label>
          <input
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Last Name</label>
          <input
            type="text"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Email Address</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {errorMessage && <div className="error-message">{errorMessage}</div>}
        {successMessage && <div className="success-message">{successMessage}</div>}
        <button type="submit">Register</button>
      </form>
    </div>
  );
};

export default Register;
